import * as types from './resetPasswordActionTypes';

const initialState = {
    mailSent: false,
    passwordChanged: false,
    hasError: false,
    errorLink: false,
    errorSubscribe: false,
    errorMessage: ''
};

const sendMailSuccess = (state, action) => {
    return{
        ...state,
        mailSent: true
    }
}

const passwordChanged = (state, action) => {
    return{
        ...state,
        passwordChanged: true
    }
}

const closeModal = (state, action) => {
    return{
        ...state,
        mailSent: false,
        passwordChanged: false,
        hasError: false,
        errorLink: false,
        errorSubscribe: false,
        errorMessage: ''
    }
}

const error = (state, action) => {
    const { errorMessage } = action;
    return {
        ...state,
        mailSent: false,
        passwordChanged: false,
        hasError: true,
        errorLink: false,
        errorMessage
    }
}

const errorLink = (state, action) => {
    const { errorMessage } = action;
    return {
        ...state,
        mailSent: false,
        passwordChanged: false,
        hasError: true,
        errorLink: true,
        errorMessage
    }
}

const errorSubscribe = (state, action) => {
    const { errorMessage } = action;
    return {
        ...state,
        mailSent: false,
        passwordChanged: false,
        hasError: true,
        errorSubscribe: true,
        errorMessage
    }
}

const reset = (state, action) => {
    return {
        ...state,
        mailSent: false,
        passwordChanged: false,
        hasError: false,
        errorLink: false,
        errorSubscribe: false,
        errorMessage: ''
    }
}

export const resetPassword = ( state = initialState, action ) => {
    switch ( action.type ) {
        case types.SEND_MAIL_SUCCESS:   return sendMailSuccess(state, action);
        case types.PASSWORD_CHANGED:    return passwordChanged(state, action);
        case types.CLOSE_MODAL:         return closeModal(state, action);   
        case types.ERROR:               return error(state, action);
        case types.ERROR_LINK:          return errorLink(state, action);
        case types.ERROR_SUBSCRIBE:     return errorSubscribe(state, action);
        case types.RESET:               return reset(state, action);
        default:                        return state;
    }
};

export default resetPassword;


// WEBPACK FOOTER //
// ./src/components/ResetPassword/resetPasswordReducers.js